function cov_1mgpk6safb() {
  var path = "/app/src/components/popup-learn-more-background-header/index.ts";
  var hash = "4d0477d061ceb9b595003360d799011624ec7d66";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/popup-learn-more-background-header/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4d0477d061ceb9b595003360d799011624ec7d66"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1mgpk6safb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1mgpk6safb();
export { PopupLearnMoreBackgroundHeader } from './popup-learn-more-background-header';